'use client';

import { c as _c } from "react/compiler-runtime";
import type { Cruz } from '@cruz-com/lookup';
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/react';
import { useQuery } from '@tanstack/react-query';
import dayjs from 'dayjs';
import _ from 'lodash';
import NextLink from 'next/link';
import { useParams } from 'next/navigation';
import { HiOutlineChatBubbleBottomCenterText } from 'react-icons/hi2';
import { twMerge } from 'tailwind-merge';
import { userApi } from '@/api';
import { Avatar, Bullet } from '@/components';
import { LeadTypeEnum, lkpLeadList } from '@/lib';
import { pages } from '@/settings';
import { useGlobalStore } from '@/store/provider';
type Props = {
  initialData: Cruz.User | undefined;
  showContactOwner: boolean;
};
export function NavUserTop(t0) {
  const $ = _c(58);
  const {
    initialData,
    showContactOwner
  } = t0;
  const {
    setMessageToOwnerType
  } = useGlobalStore(_temp);
  const params = useParams();
  const id = initialData?._id || params?.id;
  const t1 = `UserProfile_${id}`;
  let t2;
  if ($[0] !== t1) {
    t2 = [t1];
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== id) {
    t3 = () => userApi.getProfile(id as string);
    $[2] = id;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== initialData || $[5] !== t2 || $[6] !== t3) {
    t4 = {
      queryKey: t2,
      queryFn: t3,
      staleTime: 1000,
      initialData
    };
    $[4] = initialData;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const {
    data
  } = useQuery(t4);
  let t5;
  if ($[8] !== data) {
    t5 = data || {};
    $[8] = data;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const {
    first_name,
    last_name,
    user_base_url
  } = t5;
  let t6;
  if ($[10] !== data) {
    t6 = t7 => {
      const {
        name,
        href,
        count
      } = t7;
      if (_.isEmpty(data)) {
        return null;
      }
      if (_.isUndefined(count) || count === 0) {
        return null;
      }
      return <li key={href}><NextLink hrefLang="en" href={href} className="nav-item py-0.5">{name}<span className="sr-only">, count: </span><span className="nav-count">{count}</span></NextLink></li>;
    };
    $[10] = data;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const renderNavItem = t6;
  let t7;
  if ($[12] !== setMessageToOwnerType || $[13] !== showContactOwner) {
    t7 = () => {
      if (!showContactOwner) {
        return null;
      }
      const leadTypeList = _.filter(lkpLeadList, _temp2);
      const navStyle = twMerge("nav-item", "h-11");
      return <li><Popover as="div" className="relative"><PopoverButton className="nav-item py-0.5 focus-visible:outline-none"><HiOutlineChatBubbleBottomCenterText className="size-5" /><span>Contact</span></PopoverButton><PopoverPanel anchor="bottom start" transition={true} modal={false} className="menu-items w-[300px] divide-y bg-zinc-800">{_.map(leadTypeList, t8 => {
              const {
                id: id_0,
                name: name_0
              } = t8;
              return <div key={`lead_${id_0}`}><button type="button" onClick={() => setMessageToOwnerType(id_0)} className={navStyle}>{name_0}</button></div>;
            })}</PopoverPanel></Popover></li>;
    };
    $[12] = setMessageToOwnerType;
    $[13] = showContactOwner;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const renderContactOwnerMenu = t7;
  const t8 = data?.photo_url;
  const t9 = `${first_name} ${last_name}`;
  let t10;
  if ($[15] !== t8 || $[16] !== t9) {
    t10 = <Avatar className="size-16 sm:size-20" photo_url={t8} name={t9} />;
    $[15] = t8;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== first_name || $[19] !== last_name) {
    t11 = <div className="truncate text-lg font-bold">{first_name} {last_name}</div>;
    $[18] = first_name;
    $[19] = last_name;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  const t12 = data?.location?.city;
  const t13 = data?.location?.state_abbr;
  const t14 = data?.location?.zip_code;
  let t15;
  if ($[21] !== t12 || $[22] !== t13 || $[23] !== t14) {
    t15 = <span>{t12}, {t13} {t14}</span>;
    $[21] = t12;
    $[22] = t13;
    $[23] = t14;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <Bullet className="hidden px-2 sm:block" />;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <span />;
    $[26] = t17;
  } else {
    t17 = $[26];
  }
  let t18;
  if ($[27] !== data?.date_create) {
    t18 = dayjs(data?.date_create).fromNow();
    $[27] = data?.date_create;
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  let t19;
  if ($[29] !== t18) {
    t19 = <span>Joined{t17} {t18}</span>;
    $[29] = t18;
    $[30] = t19;
  } else {
    t19 = $[30];
  }
  let t20;
  if ($[31] !== t15 || $[32] !== t19) {
    t20 = <address className="flex flex-col truncate text-sm font-light not-italic sm:flex-row">{t15}{t16}{t19}</address>;
    $[31] = t15;
    $[32] = t19;
    $[33] = t20;
  } else {
    t20 = $[33];
  }
  let t21;
  if ($[34] !== renderContactOwnerMenu) {
    t21 = renderContactOwnerMenu();
    $[34] = renderContactOwnerMenu;
    $[35] = t21;
  } else {
    t21 = $[35];
  }
  const t22 = data?.statistic?.vehicle?.active || 0;
  const t23 = `${user_base_url}/vehicles`;
  let t24;
  if ($[36] !== renderNavItem || $[37] !== t22 || $[38] !== t23) {
    t24 = renderNavItem({
      ...pages.userVehicles,
      count: t22,
      href: t23
    });
    $[36] = renderNavItem;
    $[37] = t22;
    $[38] = t23;
    $[39] = t24;
  } else {
    t24 = $[39];
  }
  const t25 = data?.statistic?.spotted_count || 0;
  const t26 = `${user_base_url}/spotted`;
  let t27;
  if ($[40] !== renderNavItem || $[41] !== t25 || $[42] !== t26) {
    t27 = renderNavItem({
      ...pages.userSpotted,
      count: t25,
      href: t26
    });
    $[40] = renderNavItem;
    $[41] = t25;
    $[42] = t26;
    $[43] = t27;
  } else {
    t27 = $[43];
  }
  let t28;
  if ($[44] !== t21 || $[45] !== t24 || $[46] !== t27) {
    t28 = <ul className="mt-3 flex w-fit items-center divide-x rounded border" aria-label="User Quick Links">{t21}{t24}{t27}</ul>;
    $[44] = t21;
    $[45] = t24;
    $[46] = t27;
    $[47] = t28;
  } else {
    t28 = $[47];
  }
  let t29;
  if ($[48] !== t11 || $[49] !== t20 || $[50] !== t28) {
    t29 = <div className="pl-6">{t11}{t20}{t28}</div>;
    $[48] = t11;
    $[49] = t20;
    $[50] = t28;
    $[51] = t29;
  } else {
    t29 = $[51];
  }
  let t30;
  if ($[52] !== t10 || $[53] !== t29) {
    t30 = <section className="items-top flex w-full px-4 lg:px-0" aria-label="User Profile Summary">{t10}{t29}</section>;
    $[52] = t10;
    $[53] = t29;
    $[54] = t30;
  } else {
    t30 = $[54];
  }
  let t31;
  if ($[55] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = <div className="mb-4 border-b-4 border-zinc-100 pb-4 dark:border-zinc-800" aria-hidden="true" />;
    $[55] = t31;
  } else {
    t31 = $[55];
  }
  let t32;
  if ($[56] !== t30) {
    t32 = <div className="block lg:hidden">{t30}{t31}</div>;
    $[56] = t30;
    $[57] = t32;
  } else {
    t32 = $[57];
  }
  return t32;
}
function _temp2(x) {
  return x.id !== LeadTypeEnum.FinancingInquiry;
}
function _temp(state) {
  return state;
}